export const defaultConfig = {
    taxOfficeName: 'Tax Office',
    deliveryTaxOfficeQuestionTag: 'GOV',
    searchPlaceholder: "Search taxpayers using names or ID numbers...",
    taxId: "Tax ID",
    yearLabel: "Tax Year",
    atlasId: "Atlas ID",
    gtsId:  "GTS ID",
    entityPrimaryName: "First Name",
    entitySecondaryName: "Last Name",
    entityPrimaryNamePlaceholder: "Jane",
    entitySecondaryNamePlaceholder: "Doe",
    clientAlias: "Client",
    populationAlias: "Population",
    taxpayerAlias: "Taxpayer",
    taxReturnAlias: "Tax Return",
    taxpayerAliasPath: "taxpayers",
    taxReturnAliasPath: "tax-returns",
    smartFormAliasPath: "smart-forms",
    countryAlias: "Country"
};
